module.exports = __webpack_public_path__ + "static/img/funny_16.82f156c8.jpg";